
import LayoutContent from '../../components/layouts/content2';
import React, {useState} from 'react';

import {useTranslation} from 'react-i18next';

import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    
    const cocktails = dishs?.menus || [];

    const CocktailItem = ({ item }) => (
        <div style={{
            padding: '15px 0',
            borderBottom: '1px dashed #CCC',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }}>
            <div style={{ flex: 1, paddingRight: 20 }}>
                <h3 style={{
                    color: '#1A237E',
                    fontSize: 20,
                    fontWeight: '900',
                    margin: '0 0 5px 0',
                    fontFamily: 'Abril'
                }}>
                    {langEng ? item.name : item.name} 
                </h3>
                <p style={{
                    color: '#666',
                    fontSize: 14,
                    lineHeight: '1.4',
                    margin: 0,
                    fontFamily: 'Noto Sans'
                }}>
                    {langEng ? item.regular_decription : item.regular_decription}
                </p>
            </div>
            <div style={{
                color: '#FF2D8D',
                fontSize: 20,
                fontWeight: '900',
                fontFamily: 'Abril',
                whiteSpace: 'nowrap'
            }}>
                ${item.price?.toFixed(2)}
            </div>
        </div>
    );

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} showCocktails={ setShowCocktails} showEvents={ setShowEvents} setShowListProduct={setShowHappy} goHome={setShowHappy} goCategories={setshowCategories}>
                <div style={{padding: '0 20px', height: 780, overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 30}}>
                    
                    {/* Badge Title Pill */}
                    <div style={{
                        backgroundColor: '#FF2D8D',
                        padding: '12px 60px',
                        borderRadius: 50,
                        border: '3px solid white',
                        zIndex: 20,
                        marginBottom: -35,
                        marginTop: -30,
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <h2 style={{
                            color: 'white',
                            fontSize: 34,
                            fontWeight: '900',
                            margin: 0,
                            fontFamily: 'Abril',
                            textAlign: 'center',
                            whiteSpace: 'nowrap'
                        }}>
                            Signature Cocktails
                        </h2>
                    </div>

                    {/* Main White Card */}
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: 30,
                        padding: '60px 25px 30px 25px',
                        width: '100%',
                        boxSizing: 'border-box',
                        border: '2px solid #66C3A9',
                        marginBottom: 40,
                        zIndex: 10
                    }}>
                        {/* Banner Image */}
                        <div style={{width: '100%', marginBottom: 30}}>
                            <img
                                src={require('./assets/bannerSignature.png')}
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                    width: '100%',
                                    height: 220,
                                    objectFit: 'cover',
                                    borderRadius: 20,
                                    pointerEvents: 'none'
                                }}
                            />
                        </div>

                         <div style={{marginTop: 10, marginBottom: -20, zIndex: 10}}>
                        <img
                            src={require('./assets/textSignarure.png')}
                            style={{width: 580, height: 430, objectFit: 'contain'}}
                        />
                    </div>
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
            </LayoutContent>
        </div>
    );
}

export default Index;
